import React, { useState, useContext } from "react";
import { makeStyles, Grid, Typography, Button, IconButton } from "@material-ui/core";
import { Paper, TextField, PopUp, Loader } from "../components";
import { SendMessageIcon, ArrowBackIcon } from "../icons";
import { modals } from "../constants";
import { doctorServices } from "../services";
import { AuthContext } from "../context";
import { useHistory } from "react-router-dom";

export default function UnioSupport(props) {
  const classes = useStyles({ ...props })();
  const [indications, setIndications] = useState("");
  const [modal, setModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const { authState, signOut } = useContext(AuthContext);
  const history = useHistory();
  const onSubmit = async () => {
    try {
      setLoading(true);
      const { status, response } = await doctorServices.addDoctorReport({
        doctorId: authState.user.doctor._id,
        laboratoryId: null,
        report: indications,
        token: authState.token,
      });
      setLoading(false);
      if (status === 200) {
        setModalMessage(response.message);
        setModal(true);
        setIndications("");
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <Grid container className={classes.container}>
      {loading && <Loader loading={true} />}
      <PopUp
        modalName={modals[2]}
        open={modal}
        setModal={() => setModal(!modal)}
        message={modalMessage}
        modalSubMessage={"Por favor debe estar atento de nuestra respuesta en su correo."}
      />
      <Grid container className={classes.containerHeader} justify="center" alignItems="flex-start" style={{ padding: "5px 5px 9px 5px" }}>
        <Grid item xs={7} md={3}>
          <img src="../../assets/soporte.svg" alt="" />
        </Grid>
        <Grid item md={9}>
          <Grid container>
            <Grid item md={2} lg={1}>
              <IconButton style={{ padding: 0 }} onClick={() => history.goBack()}>
                <ArrowBackIcon />
              </IconButton>
            </Grid>
            <Grid item md={10} lg={11}>
              <Typography>Soporte Unio</Typography>
            </Grid>
            <Grid item xs={12} md={12} style={{ margin: "30px 0 0 0" }}>
              <Typography>Déjenos su comentario y nos comunicaremos con usted vía correo electrónico</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Paper>
        <Grid container className={classes.containerPaper}>
          <Grid item xs={12} className={classes.titleSupport}>
            <Typography align="center">
              Déjenos su comentario y nos <br /> comunicaremos con usted vía correo <br /> electrónico
            </Typography>
          </Grid>
          <Grid item xs={12} md={12}>
            <TextField
              containerStyle={{ margin: "20px 0 0" }}
              multiline
              rows={3}
              name={"indications"}
              value={indications}
              onChange={(e) => setIndications(e.target.value)}
              placeholder="Escribe aqui lo que deseas* "
            />
          </Grid>
          <Grid item md={4} xs={12} container style={{ margin: "23px 0 0 0" }}>
            <Button onClick={onSubmit}>
              {" "}
              ENVIAR <SendMessageIcon />{" "}
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
}

const useStyles = ({ buttonActive, ...props }) =>
  makeStyles((theme) => ({
    container: {
      display: "block",
      height: "100%",
      overflowY: "scroll",
      [theme.breakpoints.up("md")]: {
        padding: "50px 50px 0 50px",
      },
    },
    titleSupport: {
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    titleSupportDesktop: {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    containerHeader: {
      "& > div:nth-child(1)": {
        "& img": {
          [theme.breakpoints.up("md")]: {
            width: "100%",
          },
        },
      },
      "& > div:nth-child(2)": {
        padding: " 0 0 0 40px",
        [theme.breakpoints.down("sm")]: {
          display: "none",
        },
        "& > div": {
          "& > div:nth-child(2), > div:nth-child(3)": {
            "& > p": {
              color: theme.palette.primary.main,
              fontSize: "1.125rem",
              lineHeight: "1.375rem",
              fontWeight: "bold",
            },
          },
        },
      },
    },
    containerPaper: {
      height: "60vh",
      display: "block",
      "& div": {
        "& p:nth-child(1)": {
          color: theme.palette.primary.main,
          fontSize: "1.125rem",
          lineHeight: "1.375rem",
          fontWeight: "bold",
        },
        "& p": {
          color: theme.palette.secondary.main,
          fontSize: "0.875rem",
          lineHeight: "1.063rem",
          fontWeight: "500",
          margin: "10px 0 0 0",
        },
        "& button": {
          width: "45%",
          backgroundColor: theme.palette.secondary.main,
          borderRadius: 20.5,
          fontSize: "1.125rem",
          lineHeight: "1.375rem",
          fontWeight: "bold",
          color: "#FFF",
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          "&:hover": {
            backgroundColor: theme.palette.secondary.main,
          },
        },
      },
      "& > div:nth-child(3)": {
        justifyContent: "center",
        [theme.breakpoints.up("md")]: {
          justifyContent: "flex-start",
        },
      },
    },
  }));
